import React from "react";
import "./MainSection.css";
import featureImage from "../assets/feature-image.png";
import featureImageTwo from "../assets/feature-image2.png";
import featureImageThree from "../assets/feature-image3.png";
import featureImageFour from "../assets/feature-image4.png";
import appIcon from "../assets/app-icon.png";
import Footer from "./Footer.js";

const MainSection = () => {
    return (
        <>
        <div className="logo">
        <img src={appIcon} alt="ऐप आइकन" className="app-icon" />
        </div>
        <main className="hindi-main-section">
            <div className="content">
              <a
                className="hindi-download-btn"
                href="https://play.google.com/store/apps/details?id=com.maquickscanner"
                download
              >
                डाउनलोड
              </a>
            </div>
          </main>
    
          <div className="description-paragraph">
            <p>
                <strong>MA Quick Scanner</strong> खुदरा विक्रेताओं के लिए लॉटरी टिकट प्रबंधन को सरल बनाता है। यह ऐप तेज़ QR कोड स्कैनिंग, मैन्युअल टिकट प्रविष्टि, पुस्तिका बिक्री, और विस्तृत बिक्री रिपोर्ट जैसी सुविधाएँ प्रदान करता है। स्वीकृत खुदरा विक्रेताओं के लिए डिज़ाइन किया गया, यह ऐप सटीकता, दक्षता, और सुरक्षा सुनिश्चित करता है, जिससे व्यावसायिक प्रदर्शन और वृद्धि को बढ़ावा मिलता है।
            </p>
          </div>
    
          <div className="features-container">
            {[{
              image: featureImage,
              title: "टिकट प्रबंधन",
              description: "MA Quick Scanner App के साथ लॉटरी टिकटों का कुशलतापूर्वक प्रबंधन और बिक्री करें। यह बहु-उपयोगी ऐप आपको टिकट स्कैन करने, मैन्युअल रूप से विवरण दर्ज करने, और बुकलेट के रूप में बिक्री करने की सुविधा देता है, साथ ही ड्रॉ तारीखों के अनुसार टिकटों को व्यवस्थित करता है ताकि उन्हें जल्दी और आसानी से एक्सेस किया जा सके।"
            }, {
              image: featureImageTwo,
              title: "स्कैन इतिहास",
              description: "MA Quick Scanner App के स्कैन इतिहास फीचर के माध्यम से टिकट विवरण को आसानी से ट्रैक और प्रबंधित करें। इसमें आप गलत बिक्री को तुरंत हटाने के लिए ‘डिलीट स्कैन हिस्ट्री’ विकल्प का उपयोग कर सकते हैं, जिससे आपके बिक्री डेटा की सटीकता बनी रहती है।"
            }, {
              image: featureImageThree,
              title: "रिपोर्ट",
              description: "MA Quick Scanner App विस्तृत रिपोर्ट तैयार करता है, जिसमें स्टेटमेंट, खरीद, वापसी, अनसोल्ड, और पुरस्कार विजेता टिकट (PWT) रिपोर्ट शामिल हैं। ये रिपोर्ट पीडीएफ़ के रूप में डाउनलोड की जा सकती हैं, जिससे आपके लॉटरी व्यवसाय के लिए बेहतर निर्णय लेने में मदद मिलती है।"
            }, {
              image: featureImageFour,
              title: "लॉटरी परिणाम",
              description: "MA Quick Scanner App त्वरित रूप से लॉटरी परिणामों तक पहुँच प्रदान करता है, जिन्हें 'आज' और 'इतिहास' टैब में व्यवस्थित किया गया है। यह सुविधा आपको नवीनतम परिणामों की जांच करने और पिछले परिणामों की समीक्षा करने में आसानी प्रदान करती है।"
            }].map((feature, index) => (
              <section key={index} className={`feature-item ${index % 2 !== 0 ? 'reverse' : ''}`}>
                <div className="feature-image">
                  <img src={feature.image} alt="ऐप विशेषताएँ स्क्रीनशॉट" />
                </div>
                <div className="feature-content">
                  <h2>{feature.title}</h2>
                  <p>{feature.description}</p>
                </div>
              </section>
            ))}
          </div>
    
          <section className="how-to-use-section">
            <h1>कैसे उपयोग करें</h1>
            <div className="how-to-use-steps">
              <ol>
                <li><strong>डाउनलोड और इंस्टॉल करें:</strong> ऐप को Google Play Store से इंस्टॉल करने के लिए "डाउनलोड बटन" पर क्लिक करें</li>
                <li><strong>ऐप खोलें:</strong> इंस्टॉल करने के बाद ऐप खोलें और उपयोग शुरू करें!</li>
                <li><strong>स्कैन करना शुरू करें:</strong> स्कैन आइकन पर क्लिक करें और अपने लॉटरी टिकटों को स्कैन करें।</li>
                <li><strong>अपने टिकट ट्रैक करें:</strong> बेचे गए और अनबिके टिकटों को देखें और रिपोर्ट्स एक्सेस करें।</li>
                <li><strong>परिणाम देखें:</strong> लॉटरी परिणाम त्वरित रूप से जांचें।</li>
                <li><strong>रिपोर्ट जनरेट करें:</strong> रिपोर्टिंग सुविधा का उपयोग करके बिक्री रणनीति को बेहतर बनाएं।</li>
              </ol>
            </div>
            <div className="video-container">
            <h3>त्वरित उत्पाद वॉकथ्रू</h3>
            <video 
              controls 
              width="100%" 
              className="how-to-video"
              poster="https://maquickscannerappwebsite.blob.core.windows.net/maquickscannerwebpage-container/video-thumbnail.png?sp=r&st=2025-02-13T06:15:45Z&se=2030-02-13T14:15:45Z&sv=2022-11-02&sr=b&sig=W9ajKx8pfss1GIwshQ7v4DKEbpuXi8armkNTU6w4Il8%3D"
            >
            <source
             src="https://maquickscannerappwebsite.blob.core.windows.net/maquickscannerwebpage-container/MA_Quick_Scanner.mp4?sp=r&st=2025-02-11T14:11:00Z&se=2030-02-11T22:11:00Z&sv=2022-11-02&sr=b&sig=mpDitj8BzJboaN43HKtDzDcEizupqwwHkjob23%2F8zQ8%3D"
             type="video/mp4"
            />
             Your browser does not support the video tag.
            </video>
            </div>
          </section>
          <Footer/>
        </>
      );
}
export default MainSection;
